import toastMessage from "../../toastMessage";
import { getStorage } from "../../storage";
import axios from "axios";
import language from "../../../language";
import { defineRole } from "../../handleAccessRoles";
import { ROLE_REQUEST } from "../../../constants/ROLES";
import api from "../../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchShippingInQueueData = async (lng = "english", params) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_REQUEST,
      operation: "read",
    });

    // Hospital lab staff (stock or hospital field) also need to read the
    // shipping queue on the Transfer Product tab for nominative requests.
    if (!canAccess && !user.stock && !user.hospital) return;

    const options = {
      method: "GET",
      url: `${API_URL}/shipping-queue`,
      params: {
        ...params,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    console.log(queryRes.data);

    return queryRes.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_fetch_request);
  }
};

export const deleteQueue = async (lng = "english", id, type) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_REQUEST,
      operation: "delete",
    });

    if (!canAccess) return;

    const options = {
      method: "DELETE",
      url: `${API_URL}/shipping-queue`,
      data: {
        id,
        type,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await axios(options);

    toastMessage("success", language[lng].delete_data_success);
  } catch (error) {
    toastMessage("error", error);
  }
};

export const cancelShipment = async (lng = "english", shipmentNumber) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_REQUEST,
      operation: "update",
    });

    if (!canAccess) return;

    const options = {
      method: "PUT",
      url: `${API_URL}/shipping-queue`,
      data: {
        shipmentNumber,
        shipmentInfo: { status: "cancelled" },
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await axios(options);

    toastMessage("success", language[lng].update_data_success);
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchShipmentNumber = async (lng = "english", id) => {
  try {
    const user = await getStorage();
    const options = {
      method: "GET",
      url: `${API_URL}/shipment-number`,
      params: {
        tag: "count",
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};
